import { JSONElement } from "@plugins/gatsby-source-paligo/src/types";

// given a json element return the string plain text of its children
export const getPlainText = (jsonElement: JSONElement): string => {
    if (jsonElement.name === "glossary-term-reference-def") {
        return "";
    }

    if (jsonElement.type === "text") {
        return jsonElement.text || "";
    }

    return (
        jsonElement?.elements?.map(getPlainText)?.filter(Boolean)?.join("") ||
        ""
    );
};
